exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".e-drawer-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0, 0, 0, 0.4);\n  opacity: 0; visibility: hidden;\n  transition: opacity 0.3s;\n  z-index: 1000;\n}\n.e-drawer-overlay.open { opacity: 1; visibility: visible; }\n\n.e-drawer-panel {\n  position: fixed;\n  top: 0; right: -40%; width: 40%; height: 100%;\n  background: #fff;\n  box-shadow: -2px 0 8px rgba(0,0,0,0.1);\n  transition: right 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  z-index: 1001;\n  display: -ms-flexbox;\n  display: flex; -ms-flex-direction: column; flex-direction: column;\n}\n.e-drawer-panel.open { right: 0; }\n.e-drawer-header { padding: 15px 20px; border-bottom: 1px solid #e6e8ea; }\n.e-drawer-content { -ms-flex: 1; flex: 1; overflow-y: auto; padding: 20px; }\n.close-btn { background: none; border: none; font-size: 24px; cursor: pointer; color: #526069; }\n\n@media (max-width: 992px) {\n  .e-drawer-panel { width: 60%; right: -60%; }\n}\n@media (max-width: 768px) {\n  .e-drawer-panel { width: 80%; right: -80%; }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/e-drawer/e-drawer.component.css
// module id = ../../../../../src/app/components/e-drawer/e-drawer.component.css
// module chunks = 3